import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import NumbersHelper from '../helpers/numbers';

import PromotionAction from '../app/store/actions/promotion';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class PromotionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      showModal: false,
      showBulkExclusionModal: false,
      orderBy: 'DESC',
      field: 'startedAt',
      promotionsDelete: [],
    };
  }

  componentDidMount() {
    this.searchPromotions();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchPromotions();
  }

  searchPromotions = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.searchItems(limit, skip, search, orderBy, field);
  }

  setValue = (attr, value, id) => {
    if (this.state[attr] !== true) {
      this.state.promotionsDelete.push(id)
    }
    else if (this.state[attr] === true) {
      const index = this.state.promotionsDelete.indexOf(id);
      if (index != -1) {
        this.state.promotionsDelete.splice(index, 1);
      }
    }
    this.setState({
      [attr]: !value,
    });
  };

  getValue = (item) => {
    if (item.type === 'percentage') {
      return NumbersHelper.toPercentage(item.value * 100);
    }

    const decimal = Number(item.value);
    return NumbersHelper.toCurrency(decimal);
  }

  deletePromotionModal = async (promotionId) => {
    await this.setState({ selectItemToDelete: promotionId, showModal: true });
  }

  BulkPromotionModal = async () => {    
    this.setState({showBulkExclusionModal: false})
    await this.props.removePromotion(this.state.promotionsDelete);
    this.setState({promotionsDelete: []})
    await this.searchPromotions();
  }

  deletePromotion = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.removePromotion(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchPromotions();
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchPromotions();
  }

  render() {
    const {
      limit, page, showModal, showBulkExclusionModal,
    } = this.state;
    const { promotions = {} } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'code', value: I18n.t('code') },
      { key: 'description', value: I18n.t('description') },
      { key: 'type', value: I18n.t('type') },
      { key: 'value', value: I18n.t('descount') },
      { key: 'startedAt', value: I18n.t('init') },
      { key: 'finalizedAt', value: I18n.t('end') },
      { key: 'showTimer', value: I18n.t('stopWatch') },
      { key: 'action', value: I18n.t('action') },
      { key: 'delete', value: I18n.t('delete') },
    ];

    const tableData = (promotions.promotion || []).map((row, index) => ({
      key: index,
      id: row.id,
      code: row.product.code,
      description: row.product.description,
      type: row.type === 'value' ? I18n.t('cashDescount') : I18n.t('percentagemDescount'),
      value: this.getValue(row),
      startedAt: moment(row.startedAt).format('DD-MM-YYYY HH:mm:ss'),
      finalizedAt: moment(row.finalizedAt).format('DD-MM-YYYY HH:mm:ss'),
      showTimer: (
        <span className={row.showTimer ? 'status-active' : 'status-inactive'}>
          <Translate value={row.showTimer ? 'active2' : 'inactive'} />
        </span>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                onClick={() => history.push({
                  pathname: ROUTES.FORM,
                  screenComming: 'promotion',
                  item: row,
                })}
                className="dropdown-item dropdown-table"
              >
                <Translate value="edit" />
              </button>

              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deletePromotionModal(row.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
      delete: (
        <div className="d-flex justify-content-center ml-3 ">
          <input
            onClick={() => this.setValue(`delete${row.id}`, this.state[`delete${row.id}`], row.id)}
            onChange={() => { }}
            type="checkbox"
            className="form-check-input"
            checked={!!this.state[`delete${row.id}`]}
            key={`delete${row.id}`}
          />
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'promotion' }} />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_PROMOTIONS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvPromotionsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
        { (this.state.promotionsDelete.length > 0) ? 
          (<button
              onClick={() => this.setState({showBulkExclusionModal: true})}
              type="button"
              className="btn btn-danger margin-left-10"
            >
              <Translate value="deleteSelected" />
            </button>
          ) : ''
        }
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body={I18n.t((showBulkExclusionModal)?'deletePromotion':'deletePromotionModal')}
          visible={showModal || showBulkExclusionModal}
          closeModal={() => this.setState({ showModal: false, showBulkExclusionModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={(showBulkExclusionModal) ? this.BulkPromotionModal : this.deletePromotion}
        />

        <Table
          title={I18n.t('promotions')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={promotions.count && promotions.count.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  removePromotion: id => dispatch(PromotionAction.removePromotion(id)),
  searchItems: (limit, skip, search, order, field) => dispatch(
    PromotionAction.getPromotions(limit, skip, search, order, field),
  ),
  getCsvPromotionsReport: () => dispatch(PromotionAction.getCsvPromotionsReport()),
});

const mapStateToProps = state => ({
  promotions: state.promotions.promotions,
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotionPage);
